import { Domain, referrerUrl } from "@shared/utils/helpers";
import config from "../../auth_config.json";
import packageJson from "../../package.json";

const connection = referrerUrl.endsWith(Domain.MAIN) ? config.connection : "";
const apiUri = "https://api-dev.wpay.wezaam.com";

export const environment = {
	appVersion: packageJson.version + "-dev",
	production: false,
	auth: {
		domain: config.domain,
		clientId: config.clientId,
		forgeRockDomain: config.forgeRockDomain,
		redirectUri: window.location.origin,
		audience: config.audience,
		connection
	},
	httpInterceptor: {
		allowedList: [`${apiUri}/*`]
	},
	apiUri: apiUri,
	showGlobalDashboard: true,
	typeEnvForgeRock: "rc-",
	pendoApiKey: "c04126f4-2829-4c03-65c8-588dea04d089",

	pingIdentity: {
		authUrl: "https://account-dev.cloudpay.net",
		cloudSpaceUrl: "https://cloudpayasia.sharepoint.com/sites/CloudSpace"
	}
};
